import React from 'react'
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import { EventDate, EventInfo, EventInfoItem, EventItem ,EventText } from './Style';

export default function Event(props) {
    return (
        <ScrollAnimation animateIn="animate__zoomIn">
            <EventItem>
                <img src={props.image} />
                <EventText>
                    <a href="#">{props.title}</a>
                    <p>
                        Lorem ipsum dolor sit amet, conse ctetur adi pisicin g elit.
                        Doloribus repel lendus, pariatur qui provident repel lendus!
                    </p>
                </EventText>
                <hr />
                <EventInfo>
                    <EventInfoItem>
                        <i className="fas fa-user"></i> <span>John Wood</span>
                    </EventInfoItem>
                    <span></span>
                    <EventInfoItem>
                        <i className="fas fa-map-marker-alt"></i> <span> New York City</span>
                    </EventInfoItem>
                </EventInfo>
                <EventDate>
                    <span>16</span>
                    <span>June</span>
                </EventDate>
            </EventItem>
        </ScrollAnimation>
    )
}
